<template>
  <div class="menu-user">
    <v-menu v-model="menuOpen" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div class="user-container" v-bind="attrs" v-on="on">
          <v-avatar size="56" class="white--text text-h5" :color="avatarCor">
            <img v-if="user && imagemUrl" :src="imagemUrl" />
            <img v-else-if="user && user.role === 'Host'" src="../assets/images/Medics/Logo Medics Vertical.png" />
            <span v-else>
              {{ formatarIniciaisNomeCompleto(user.nomeCompleto) }}
            </span>
          </v-avatar>
          <div class="user-info">
            <span>{{ user.nomeCompleto }}</span>
            <h5>{{ (user.role === 'Admin' || user.role === 'Admin_Medico') ? 'Administrador Master' : user.role }}</h5>
          </div>
          <v-spacer></v-spacer>
          <v-icon>{{ menuOpen ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
        </div>
      </template>
      <v-list class="menu-list">
        <v-list-item v-if="user && (user.role === 'Admin' || user.role === 'Admin_Medico')" class="menu-item"
          @click="$router.push({ name: 'clinicasFormUpdate' })">
          <v-icon>$clinical</v-icon>
          <span>Clínica</span>
        </v-list-item>
        <v-list-item v-if="user.role === 'Host'" class="menu-item"
          @click="$router.push({ name: 'clinicasFormUpdate' })">
          <v-icon>$clinical</v-icon>
          <span>Criar Clínica</span>
        </v-list-item>
        <v-list-item v-else @click="$router.push({ name: 'perfilDoUsuario' })">
          <v-icon>$profile</v-icon>
          <span>Perfil</span>
        </v-list-item>
        <v-list-item @click="alterarTemaDoSistema">
          <v-icon>{{ modoNoturno ? '$lightMode' : '$darkMode' }}</v-icon>
          <span> {{ modoNoturno ? "Modo Claro" : "Modo Escuro" }}</span>
        </v-list-item>
        <v-list-item @click="sair()">
          <v-icon>mdi-door-open</v-icon>
          <span>Sair</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import NavigationHelper from '../helpers/NavigationHelper';
import {
  getModoNoturno,
  removeToken,
  setModoNoturno,
  decode,
  getToken,
} from '../utils/Token';
import { AlertaSimplesErro, AlertaPerguntaSimOuNaoBooleano } from '../helpers/MensagemHelper';
import { UsuarioService } from '../services/UsuarioService';
import { ArquivoS3Service } from '../services/ArquivoS3Service';
import { mapGetters } from 'vuex';
import { CoresHelper } from '../utils/coresHelper';
import { LoginService } from '@/services/LoginService';

interface ImagemCache {
  url: string;
  timestamp: number;
  chave: string;
}

export default Vue.extend({
  name: 'UserMenu',
  data() {
    return {
      menuOpen: false,
      user: {
        nomeCompleto: '',
        profilePicture: '',
        role: '',
      },
      modoNoturno: getModoNoturno(),
      imagemUsuario: null as string | null,
      carregandoImagem: false,
      arquivoS3Service: new ArquivoS3Service(),
    };
  },
  computed: {
    imagemUrl(): string | null {
      return this.imagemUsuario || this.$store.getters['usuario/imagemUrl'];
    },
    avatarCor() {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--especialidade-primary').trim();
      return primaryColor || '#2e4b9d';
    },
    ...mapGetters('usuario', []),
  },
  watch: {
    user() {
      this.modoNoturno = getModoNoturno();
    },
  },
  mounted() {
    const token = getToken();

    if (token) {
      const currentUser = decode(token);
      const currentUserId = currentUser?.id;
      const keysToCheck = [];

      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key && key.startsWith('user_image_') && !key.includes(`user_image_${currentUserId}`)) {
          keysToCheck.push(key);
        }
      }

      if (keysToCheck.length > 0) {
        this.limparTodoCacheImagens();
        this.imagemUsuario = null;
        this.$store.dispatch('usuario/atualizarImagem', null);
      }
    }

    this.atualizarInformacoesUsuario();
    this.carregarImagemUsuario();
    this.$root.$on('atualizar-usuario', this.atualizarInformacoesUsuario);
    this.$root.$on('imagem-usuario-atualizada', this.onImagemUsuarioAtualizada);
    this.$vuetify.theme.dark = this.modoNoturno;
  },
  beforeDestroy() {
    this.$root.$off('atualizar-usuario', this.atualizarInformacoesUsuario);
    this.$root.$off('imagem-usuario-atualizada', this.onImagemUsuarioAtualizada);
  },
  methods: {
    atualizarInformacoesUsuario() {
      const token = getToken();

      if (token) {
        const novoUser = decode(token);
        const usuarioAnteriorId = this.user?.id;
        const novoUsuarioId = novoUser?.id;

        if (usuarioAnteriorId && novoUsuarioId && usuarioAnteriorId !== novoUsuarioId) {
          this.limparTodoCacheImagens();
          this.imagemUsuario = null;
          this.$store.dispatch('usuario/atualizarImagem', null);
        }

        this.user = novoUser;
        this.invalidarCacheImagem();
        this.carregarImagemUsuario();
      }
    },
    async carregarImagemUsuario() {
      if (this.carregandoImagem) {
        return;
      }

      try {
        this.carregandoImagem = true;
        const usuarioId = this.user?.usuarioId || this.user?.id || this.$store.getters['usuario/usuarioId'];

        if (!usuarioId) {
          this.imagemUsuario = null;
          return;
        }

        this.verificarELimparCacheOutroUsuario(usuarioId);
        const storeImagemUrl = this.$store.getters['usuario/imagemUrl'];

        if (storeImagemUrl) {
          if (storeImagemUrl.includes && !storeImagemUrl.includes(usuarioId) && storeImagemUrl.includes('amazonaws.com')) {
            this.$store.dispatch('usuario/atualizarImagem', null);
          } else if (storeImagemUrl.includes('data:image')) {
            const base64Match = storeImagemUrl.match(/data:image[^,]*,(.+)/);

            if (base64Match) {
              const base64Data = base64Match[0];
              this.imagemUsuario = base64Data;
              this.salvarImagemNoCache(usuarioId, base64Data, base64Data);
              return;
            }
          } else if (storeImagemUrl.startsWith('http') || storeImagemUrl.startsWith('blob:')) {
            this.imagemUsuario = storeImagemUrl;
            this.salvarImagemNoCache(usuarioId, storeImagemUrl, storeImagemUrl);
            return;
          }
        }

        const imagemCacheada = this.obterImagemDoCache(usuarioId);

        if (imagemCacheada) {
          this.imagemUsuario = imagemCacheada.url;
          this.$store.dispatch('usuario/atualizarImagem', imagemCacheada.chave);
          return;
        }

        const chaveImagem = this.user?.chaveImagemPerfil || this.$store.getters['usuario/imagemUrl'];

        if (!chaveImagem) {
          this.imagemUsuario = null;
          return;
        }

        if (chaveImagem.startsWith('http') || chaveImagem.startsWith('blob:') || chaveImagem.startsWith('data:')) {
          this.imagemUsuario = chaveImagem;
          this.salvarImagemNoCache(usuarioId, chaveImagem, chaveImagem);
          return;
        }

        const response = await this.arquivoS3Service.ObterUrlImagem(chaveImagem);

        if (response?.data?.caminhoArquivo) {
          const urlImagem = response.data.caminhoArquivo;
          this.imagemUsuario = urlImagem;
          this.salvarImagemNoCache(usuarioId, chaveImagem, urlImagem);
          this.$store.dispatch('usuario/atualizarImagem', chaveImagem);
        }
      } catch (error) {
        console.error('[UserMenu] Erro ao carregar imagem:', error);
        this.imagemUsuario = null;
      } finally {
        this.carregandoImagem = false;
      }
    },
    obterImagemDoCache(usuarioId: string): ImagemCache | null {
      try {
        const cacheKey = `user_image_${usuarioId}`;
        const cache = localStorage.getItem(cacheKey);

        if (!cache) {
          return null;
        }

        const imagemCache: ImagemCache = JSON.parse(cache);
        const agora = Date.now();
        const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 horas

        if (agora - imagemCache.timestamp < CACHE_DURATION) {
          return imagemCache;
        }

        localStorage.removeItem(cacheKey);
        return null;
      } catch (error) {
        console.warn('Erro ao ler cache de imagem:', error);
        return null;
      }
    },
    salvarImagemNoCache(usuarioId: string, chave: string, url: string) {
      try {
        const cacheKey = `user_image_${usuarioId}`;
        const imagemCache: ImagemCache = {
          url,
          chave,
          timestamp: Date.now(),
        };
        localStorage.setItem(cacheKey, JSON.stringify(imagemCache));
      } catch (error) {
        console.warn('Erro ao salvar cache de imagem:', error);
      }
    },
    invalidarCacheImagem(usuarioId?: string) {
      const userId = usuarioId || this.user?.usuarioId || this.user?.id || this.$store.getters['usuario/usuarioId'];

      if (userId) {
        const cacheKey = `user_image_${userId}`;
        localStorage.removeItem(cacheKey);
      }
    },
    limparTodoCacheImagens() {
      const keysToRemove = [];

      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key && key.startsWith('user_image_')) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach((key) => {
        localStorage.removeItem(key);
      });
    },
    verificarELimparCacheOutroUsuario(usuarioAtualId: string) {
      const keysOutrosUsuarios = [];

      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key && key.startsWith('user_image_') && key !== `user_image_${usuarioAtualId}`) {
          keysOutrosUsuarios.push(key);
        }
      }

      if (keysOutrosUsuarios.length > 0) {
        keysOutrosUsuarios.forEach((key) => {
          localStorage.removeItem(key);
        });

        this.imagemUsuario = null;
      }
    },
    onImagemUsuarioAtualizada(novaChave: string) {
      if (novaChave && (novaChave.startsWith('data:') || novaChave.startsWith('http') || novaChave.startsWith('blob:'))) {
        this.imagemUsuario = novaChave;
        const usuarioId = this.$store.getters['usuario/usuarioId'] || this.user?.usuarioId || this.user?.id || 'default';

        if (usuarioId && usuarioId !== 'default') {
          this.salvarImagemNoCache(usuarioId, novaChave, novaChave);
        }

        this.$store.dispatch('usuario/atualizarImagem', novaChave);
        return;
      }

      this.invalidarCacheImagem();
      this.imagemUsuario = null;
      this.carregarImagemUsuario();
      this.$store.dispatch('usuario/atualizarImagem', novaChave);
    },
    async alterarTemaDoSistema() {
      try {
        const usuarioService = new UsuarioService();
        const res = await usuarioService.MudarTema();
        this.modoNoturno = res.data;
        this.$vuetify.theme.dark = this.modoNoturno;
        setModoNoturno(this.modoNoturno);
      } catch (err) {
        AlertaSimplesErro('Não foi possível realizar a operação', err);
      }
    },
    async sair() {
      if (await AlertaPerguntaSimOuNaoBooleano('Deseja sair do sistema?')) {
        try {
          const loginService = new LoginService();
          await loginService.logout();
        } catch (error) {
          console.error('Erro ao realizar logout:', error);
        }

        this.limparTodoCacheImagens();
        this.imagemUsuario = null;
        this.$store.dispatch('usuario/atualizarImagem', null);
        removeToken();
        this.$vuetify.theme.dark = false;
        CoresHelper.limparEspecialidade();
        NavigationHelper.navigate('login');
      }
    },
    formatarIniciaisNomeCompleto(nomeCompleto: string) {
      if (!nomeCompleto) {
        return 'H';
      }

      const partes = nomeCompleto.trim().split(' ');

      if (partes.length === 1) {
        return partes[0].charAt(0).toUpperCase();
      }

      return partes[0].charAt(0).toUpperCase() + partes[partes.length - 1].charAt(0).toUpperCase();
    },
  },
});
</script>

<style scoped>
.menu-user {
  margin-left: 1.875rem;
  margin-top: 1rem;
  display: flex;
  align-items: center;
  padding: 0.75rem;
  cursor: pointer;
}

.user-container {
  display: flex;
  align-items: center;
}

.user-container .v-avatar img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  border-radius: 50% !important;
}

.menu-list {
  padding: 1rem;
}

.menu-item {
  padding-left: 1rem;
}

.v-icon {
  margin-right: 1rem;
}

.user-info {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.user-info span {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  text-align: justify;
  color: var(--text-primary, #4E4E4E);
}

.user-info h5 {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--text-muted, #A4A8AB);
}

.v-list-item span {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: var(--text-primary, #4E4E4E);
}

.v-list-item .v-icon {
  color: var(--text-primary, #4E4E4E);
}

.v-menu__content {
  margin-top: 1rem;
}

/* Dark mode overrides */
.theme--dark .user-info span {
  color: #e6e6e6;
}

.theme--dark .user-info h5 {
  color: #b0b0b0;
}

.theme--dark .v-list-item span {
  color: #e6e6e6;
}

.theme--dark .v-list-item .v-icon {
  color: #e6e6e6;
}
</style>
